export const PREVIEW_CLASSNAME = 'HS_GLOBAL_STYLES_PREVIEW';
export const CSS_VAR_STYLE_EL_ID = 'HS_CSS_VARS';
export const FONTS_BASE_KEY = ['groupFoundation', 'groupFonts', 'groupFontElements'];
export const FONT_FIELD_KEYS = {
  HEADING_FONT_KEY: ['groupHeadings', 'groupAllHeadings', 'allHeadings'],
  BODY_FONT_KEY: ['groupBody', 'paragraph'],
  BLOCK_QUOTE_FONT_KEY: ['groupOtherElements', 'blockquote']
};